module.exports = __webpack_public_path__ + "static/img/language_zh.3d49c4b1.png";